const AUTH = 'AUTH'

export const campsiteHelper = {
  methods: {
    getCookie (name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
      return v ? v[2] : null
    },
    setCookie (name, value) {
      document.cookie = name + '=' + value
    },
    getAuthCookie () {
      return this.getCookie(AUTH)
    },
    setAuthCookie (value) {
      this.setCookie(AUTH, value)
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/campsiteHelperMixin.js